import { Container } from 'src/components/common/Container'
import styled from 'styled-components'
import { Divider } from 'src/components/common/Divider'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { FreeCouponPageProps } from 'src/pages/FreeCouponPage/index'
import { FreeCouponListSpace } from 'src/types/api'
import { layoutMaxSize } from 'src/styles/mixin'
import React from 'react'
import FreeCouponCard from 'src/pages/FreeCouponPage/_components/FreeCouponCard'
import RenderIf from 'src/components/common/RenderIf'

const FreeCouponView = ({ FreeCouponListData, freeCouponDetailNav }: FreeCouponPageProps) => {
  return (
    <S.FreeCouponContainer $option="flex_column">
      <RenderIf when={!FreeCouponListData}>
        <S.EmptyFreeCouponItemsWrap $option="flex_column">
          <Typography $fontStyle={Noto_body1_r16} $color={'var(--black-30)'}>
            보유하신 혜택 쿠폰이 없습니다.
          </Typography>
        </S.EmptyFreeCouponItemsWrap>
      </RenderIf>
      {FreeCouponListData?.map(
        ({ Coupons, Group }: FreeCouponListSpace.FreeCouponTypes, index: number) => (
          <Container $option="flex_column" key={index}>
            <S.FreeCouponContents $option="flex_column">
              <Typography $fontStyle={Noto_subheading_b18}>{Group}</Typography>
              {Coupons?.map((coupon: FreeCouponListSpace.FreeCouponItemsType) => (
                <FreeCouponCard
                  {...coupon}
                  key={coupon.Idx}
                  freeCouponDetailNav={freeCouponDetailNav}
                />
              ))}
            </S.FreeCouponContents>
            <Divider disabled={FreeCouponListData?.length - 1 === index} />
          </Container>
        ),
      )}
    </S.FreeCouponContainer>
  )
}
export default FreeCouponView

const S = {
  EmptyFreeCouponItemsWrap: styled(Container)`
    justify-content: center;
    text-align: center;
    height: 200px;
    flex: 1;
  `,
  FreeCouponContainer: styled(Container)`
    column-gap: 30px;
    flex: 1;
  `,
  FreeCouponContents: styled(Container)`
    margin: 30px auto;
    ${layoutMaxSize};
    gap: 14px;
    padding: 0 20px;
  `,
}
